import { __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { SharedHttp } from '../../services/http-client.service';
import { DomSanitizer } from '@angular/platform-browser';
import { WebsiteThemeService } from '../../services/website-theme.service';
/**
 * FAQ Component
 */
let FaqComponent = class FaqComponent {
    constructor(httpClient, sanitizer, themeService) {
        this.httpClient = httpClient;
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.faqCategories = [];
        this.faqNews = [];
        this.accentColor = '';
        this.questionsColor = '';
        this.backColor = '';
        this.arrowColor = '';
        this.mainColor = '';
        this.activeCategoryTitle = '';
        this.borderRadiusSmaller = '';
        this.httpClient.get('info/faq_categories').subscribe((result) => {
            this.faqCategories = result;
        });
        this.themeService.getTheme().subscribe((data) => {
            this.accentColor = this.themeService.getStyleAttribute('accent_color');
            this.questionsColor = this.themeService.getStyleAttribute('faq_questions_color');
            this.backColor = this.themeService.getStyleAttribute('side_menu');
            this.arrowColor = this.themeService.getStyleAttribute('success_color');
            this.mainColor = this.themeService.getStyleAttribute('main_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
        });
    }
    ngOnInit() {
        let scrollStep = -window.scrollY / (100 / 15), scrollInterval = setInterval(function () {
            if (window.scrollY != 0) {
                window.scrollBy(0, scrollStep);
            }
            else
                clearInterval(scrollInterval);
        }, 15);
    }
    clickCategories(idCategories, index) {
        if (this.idCategories === idCategories) {
            this.idCategories = 999;
            this.faqNews = null;
            this.active = -1;
            this.activeCategoryTitle = '';
        }
        else {
            this.activeCategoryTitle = this.faqCategories[index].name;
            this.idCategories = idCategories;
            const linkFaq = 'info/faq/' + idCategories;
            this.httpClient.get(linkFaq).subscribe((result) => {
                this.faqNews = result;
                this.active = -1;
                //to navigate to the part with the news
                this.sectionLink = document.getElementById('list_link').scrollIntoView({ behavior: 'smooth', block: 'start' });
            });
        }
    }
    setActive(id) {
        if (this.active === id) {
            this.active = -1;
        }
        else {
            this.active = id;
        }
    }
};
FaqComponent.ctorParameters = () => [
    { type: SharedHttp },
    { type: DomSanitizer },
    { type: WebsiteThemeService }
];
FaqComponent = __decorate([
    Component({
        selector: 'ecd-faq',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./faq.component.html")).default
    })
], FaqComponent);
export { FaqComponent };
